module.exports = __webpack_public_path__ + "static/media/titan_light_logo.b59596bf.svg";